import React from 'react'
import Chart from 'react-apexcharts'

export default function TopLossUsersChart({ topLoss }) {
  const lossUsers = (topLoss || [])
    .filter((u) => u.user_pl < 0)
    .sort((a, b) => a.user_pl - b.user_pl)
    .slice(0, 5)

  const values = lossUsers.map((u) => Math.abs(u.user_pl))
  const names = lossUsers.map((u) => u.user_name)

  const defaultCategories = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
  ]

  const options = {
    xaxis: {
      categories: lossUsers.length > 0 ? names : defaultCategories,
    },
    legend: {
      show: false,
    },
    plotOptions: {
      bar: {
        distributed: true,
        columnWidth: '20px',
        dataLabels: {
          position: 'top',
        },
      },
    },
    dataLabels: {
      enabled: false,
    },
  }

  const series = [
    {
      name: 'Loss Amount',
      data:
        values.length > 0 ? values : Array(defaultCategories.length).fill(0),
    },
  ]

  return (
    <div className="nw-affi-graph-wrapper">
      <div
        className="w-full flex px-3 gap-x-1 py-2 bg-bg_Secondary"
        style={{ padding: '5px' }}
      >
        <h3 className="nw-affi-heading-text">Top 5 Loss Users</h3>
      </div>

      <div className="af-graph-img-sec" style={{ minHeight: '265px' }}>
        <Chart options={options} series={series} type="bar" height={250} />
      </div>
    </div>
  )
}
